<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="货币code">
                  <el-input v-model="queryForm.code" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="showForm">创建新币种</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="fromCountry" label="货币code"></el-table-column>
      <el-table-column prop="currentRate" label="货币转EUR汇率"></el-table-column>
    </el-table>

    <el-dialog append-to-body title="创建新币种" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item prop="fromCountry" label="货币code" :rules="[{ required: true, message: '请输入货币code' }]">
          <el-input v-model="form.fromCountry" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item prop="currentRate" label="货币转EUR汇率" :rules="[{ required: true, message: '请输入货币转EUR汇率' }, { type: 'number', min: 0.0001, message: '不能小于0'}]">
          <el-input-number v-model="form.currentRate" :precision="4" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认创建</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getListExchangeRate,
  createPriceUnit,
} from "./rate/api";

export default {
  data() {
    return {
      queryForm: {
        code: null,
      },
      tableData: [],
      dialogVisible: false,
      form: {
        fromCountry: null,
        currentRate: undefined,
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.getTableData();
    },
    reset() {
      this.queryForm.code = null;
      this.getTableData();
    },
    getTableData() {
      getListExchangeRate(this.queryForm).then(res => {
        this.tableData = res.data.data;
      })
    },
    showForm() {
      this.form.fromCountry = '';
      this.form.currentRate = undefined;
      this.dialogVisible = true;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            createPriceUnit(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.data) {
                this.$message.success('创建成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.message || '货币code已存在');
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
